import axios from 'axios';
import authHeader from '../../../app/axios/header';
import { IUserWord } from '../types';

export const createUserWords = async (userId: string, wordId: string, wordData: IUserWord) => {
  return axios
    .post(process.env.REACT_APP_API_URL + `users/${userId}/words/${wordId}`, wordData, {
      headers: authHeader(),
    })
    .then((response) => {
      return response;
    });
};

export const deleteUserWord = (id: string, wordId: string) => {
  axios
    .delete(process.env.REACT_APP_API_URL + `users/${id}/words/${wordId}`, {
      headers: authHeader(),
    })
    .then((response) => {
      return response.data;
    });
};

export const updateUserWords = (userId: string, wordId: string, wordData: IUserWord) => {
  return axios
    .put(process.env.REACT_APP_API_URL + `users/${userId}/words/${wordId}`, wordData, {
      headers: authHeader(),
    })
    .then((response) => {
      return response.data;
    });
};

export const getUserWordsId = async (userId: string, wordId: string) => {
  axios.get(process.env.REACT_APP_API_URL + `users/${userId}/words/${wordId}`).then((response) => {
    return response.data;
  });
};
